<template>
  <div id="valuesWrapper">
    <div class="notification">
      <options-buttons
        @edit="edit"
        @delete="remove">
      </options-buttons>

      {{ question.value }}

      <div
        class="content is-size-7"
        v-show="isAdmin(account)">

        <ul v-if="!inAdmin">
          <li
            v-for="(bundle, idx) in question.bundles"
            :key="idx">

            {{ getBundleName(bundle) }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { authMixin } from '@/mixins'
import OptionsButtons from '@/components/modules/OptionsButtons'

export default {
  mixins: [
    authMixin
  ],
  props: [
    'question'
  ],
  components: {
    OptionsButtons
  },
  computed: {
    ...mapGetters({
      account: 'account/account',
      dossier: 'dossiers/dossier',
      bundles: 'bundles/bundles'
    })
  },
  methods: {
    edit () {
      this.$emit('edit', this.question)
    },
    remove () {
      this.$emit('remove', this.question)
    },
    getBundleName (bundleId) {
      const bundle = this.bundles.find(x => x.id === bundleId)

      return (bundle) ? bundle.name : 'Bundel niet beschikbaar'
    }
  }
}
</script>

<style scoped>
  #valuesWrapper {
    margin-bottom: 30px;
  }
</style>
